import React from 'react'
import { ArticleLayout } from '@components/common'
import { Button, CTA } from '@components/ui'
import { Box, Typography } from '@mui/material'
import commentMarche from '@assets/images/bandeau-comment-marche.jpg'
import commentMarcheWebP from '@assets/images/bandeau-comment-marche.webp'
import plat from '@assets/images/img-plat.png'
import platWebP from '@assets/images/img-plat.webp'
import cook from '@assets/images/img-cook.png'
import cookWebP from '@assets/images/img-cook.webp'
import bowl from '@assets/images/img-gamelle.png'
import bowlWebP from '@assets/images/img-gamelle.webp'
import CheckmarkIcon from '@assets/images/svg/ico-check.svg'
import PanierIcon from '@assets/images/svg/ico-panier.svg'
import ParagraphWithImage from '@components/common/content/ParagraphWithImage'
import { withLayout, withProps } from '@utils/hoc'
import useResponsive from '@utils/hooks/useResponsive'
import { PageComponent } from 'types/app'
import colors from '@const/colors.json'
import routes from '@const/routes'
import { withStyles } from '@mui/styles'

const Order = withStyles({
  root: {
    color: colors.white,
    textAlign: 'center'
  }
})(withProps(Typography, { variant: 'h2', component: 'h2' }))

const CommentCaMarche: PageComponent = () => {
  const small = useResponsive(372).responsive

  const Paragraphs = [
    {
      title: 'Choisissez vos plats :',
      image: (
        <picture>
          <source srcSet={platWebP.src} type="image/webp" />
          <img src={plat.src} height={small ? 250 : 350} width={small ? 250 : 350} alt="plat" />
        </picture>
      ),
      items: [
        {
          text: 'Vous pouvez passer votre commande pour la semaine en cours ainsi que les deux semaines suivantes',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Chaque semaine de nouveaux plats parmis nos 8 menus',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Vous êtes libres de choisir parmis une entrée et un plat, un plat et un dessert, ou pour les plus gourmands, le menu complet',
          icon: <CheckmarkIcon />
        }
      ]
    },
    {
      title: 'On prépare tout :',
      image: (
        <picture>
          <source srcSet={cookWebP.src} type="image/webp" />
          <img src={cook.src} height={small ? 250 : 350} width={small ? 250 : 350} alt="cook" />
        </picture>
      ),
      reverse: true,
      items: [
        {
          text: 'Choisissez parmis nos contenants : la Gamelle ou la barquette',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Des allergies ou préférences alimentaires ? Pas de soucis, utilisez votre profil pour nous l‘indiquer et commander sereinement',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Vous aimez partager ? Nous pouvons mettre deux portions dans le même contenant',
          icon: <CheckmarkIcon />
        }
      ]
    },
    {
      title: 'Utilisez vos gamelles :',
      image: (
        <picture>
          <source srcSet={bowlWebP.src} type="image/webp" />
          <img src={bowl.src} height={small ? 250 : 350} width={small ? 250 : 350} alt="bowl" />
        </picture>
      ),
      items: [
        {
          text: 'Emmenez vos Gamelles compartimentées, à la boutique Super Ya, la veille avant midi',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Nous conditionnons et livrons vos menus en Gamelles',
          icon: <CheckmarkIcon />
        },
        {
          text: 'Faites des économies et un geste pour le développement durable',
          icon: <CheckmarkIcon />
        }
      ]
    }
  ]

  return (
    <>
      {Paragraphs.map((paragraph, key) => (
        <div key={key} className="mx-auto mt-[100px] sm:w-[500px] lg:w-[920px]">
          <ParagraphWithImage title={paragraph.title} image={paragraph.image} items={paragraph.items} reverse={paragraph.reverse} />
        </div>
      ))}
    </>
  )
}

const Layout = withProps(ArticleLayout, {
  banner: (
    <picture>
      <source srcSet={commentMarcheWebP.src} type="image/webp" />
      <img src={commentMarche.src} alt="comment ça marche" className="min-w-full rounded" width={1220} height={140} />
    </picture>
  ),
  title: 'Comment ça marche',
  subtitle: 'Rien de plus simple pour déguster nos gamelles que ça soit au bureau, à la maison ou sur la plage',
  additional: (
    <div className="mx-[20px] mt-[70px] flex flex-col items-center justify-between rounded bg-super-ya-blue1 py-[50px] xl:mx-auto xl:w-[1110px] ">
      <Order>Vous êtes prêts à commander ?</Order>
      <Box boxShadow={0}>
        <CTA
          wrapper={withProps(Button, {
            variant: 'contained',
            color: 'secondary',
            className: 'mt-10'
          })}
          url={routes.menus.uri}
          label="Je remplis mon panier"
          icon={<PanierIcon />}
          color={colors.blue3}
          hover={colors.blue3}
          reverse
        />
      </Box>
    </div>
  )
})

export default withLayout(CommentCaMarche, Layout)
